<template>
  <v-card
  flat
  height="100%"
  tile
  id="playlistTextEditorCard"
  tabindex="-1"
  ref="textEditorCard"
  :ripple="false">
    <v-list
    :color="playlistColor"
    height="65"
    dark
    tile>
      <v-list-item :color="playlistColor">
        <v-list-item-avatar>
          <v-btn icon @click="closeSlideout" aria-label="Close add attachment tab">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            Edit text element<v-icon class="ml-2">mdi-card-text-outline</v-icon>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-container>
      <v-card
        flat
        class="mt-2">
        <v-card-title class="playlist-headline font-weight-light black--text">
          Edit Text Item
        </v-card-title>
        <v-card-text>
          <v-text-field
            id="textTitleInput"
            v-model.trim="textTitle"
            label="Text title"
            prepend-icon="mdi-text-short"
            :error-messages="textTitleErrors"
            @input="$v.textTitle.$touch"
            :color="playlistColor"
          ></v-text-field>
          <TinyMCE
            aria-label="Playlist rich text editor"
            :apiEnabled="true"
            :token="userToken"
            mode="text-editor-update"
            :tinymceKey="slideoutData.data.itemId"
            :footerKey="playlist.id"
            :initial-text="tinymceContent"
            service="playlist"
            :brandingColor="playlistColor"
            submissionButtonText="Update Text"
            :submitFunction="handleUpdateText"
            deletionButtonText="Delete Text"
            :deleteFunction="handleRemoveText"
          />
        </v-card-text>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';

import _ from 'lodash';
import {
  maxLength,
  required,
} from 'vuelidate/lib/validators';

export default {
  name: 'TextEditor',
  props: [
    'open',
  ],
  data: () => ({
    textTitle: '',
  }),
  computed: {
    ...mapState([
      'isUpdating',
      'playlist',
      'slideoutData',
      'userToken',
    ]),
    playlistColor() {
      return _.get(this.playlist, 'default_color', '#2196F3');
    },
    textTitleErrors() {
      const errors = [];
      if (!this.$v.textTitle.$dirty) return errors;
      if (!this.$v.textTitle.required) errors.push('A title is required.');
      if (!this.$v.textTitle.maxLength) errors.push('The max length is 255 characters.');
      return errors;
    },
    tinymceContent() {
      return this?.slideoutData?.data?.text?.body ?? '';
    },
  },
  methods: {
    ...mapMutations([
      'setIsUpdating',
      'setModuleSelected',
      'setPlaylist',
      'setSlideout',
      'toggleSnackbar',
    ]),
    ...mapActions([
      'removeItem',
    ]),
    closeSlideout() {
      this.setModuleSelected(null);
      this.setSlideout(null);
    },
    async handleUpdateText(value) {
      try {
        const { moduleId } = this.slideoutData.data;
        const { id } = this.slideoutData.data.text;
        this.setIsUpdating(true);
        this.setSlideout(null);
        const { data: { playlist: updatedPlaylist } } = await this.$api.module.updateText({
          playlistId: this.playlist.id,
          moduleId,
          text: {
            id,
            title: this.textTitle,
            body: value,
          },
        });
        this.setPlaylist(updatedPlaylist);
      } catch(e) {
        this.toggleSnackbar({
          text: 'Error adding text.',
          color: 'error',
        });
      } finally {
        this.setModuleSelected(null);
        this.setIsUpdating(false);
      }
    },
    handleRemoveText() {
      this.removeItem({
        playlistId: this.playlist.id,
        moduleId: this.slideoutData.data.moduleId,
        oldItemIndex: this.slideoutData.data.order,
        itemId: this.slideoutData.data.itemId,
        type: 'text',
      });
      this.setSlideout(null);
    },
  },
  validations: {
    textTitle: {
      maxLength: maxLength(255),
      required,
    },
  },
  mounted() {
    this.textTitle = this.slideoutData.data.text.title;
  },
  watch: {
    async slideoutData(newValue, oldValue) { // eslint-disable-line
      if (
        newValue
        && newValue.type === 'textEdit'
      ) {
        await this.$nextTick();
        setTimeout(() => {
          this.$refs.textEditorCard.$el.focus();
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
  .aria-feedback {
    text-indent: -10000px;
    font-size: 0.1px;
  }
</style>
